import Marquee from "react-fast-marquee";

const ITEMS = ["Photoshop", "Illustrator", "Premiere Pro", "After Effects", "Lightroom", "Adobe XD", "Web Design"];

export default function MarqueeBand() {
  return (
    <div
      data-testid="marquee-band"
      className="border-y border-white/10 bg-[#0a0a0a] py-8 md:py-10"
    >
      <Marquee speed={28} gradient={false} autoFill>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center">
            <span className="text-stroke font-display px-6 text-4xl font-extrabold uppercase tracking-tight md:px-10 md:text-6xl">
              {item}
            </span>
            <span className="h-2.5 w-2.5 rounded-full bg-[#00E5FF]" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
